<template>
  <div class="wrapper">
    <h2>Project Tasks</h2>
    <ProjectTask  v-for="(item, key) in $store.getters.currentProjectModuleColumns.hourlyElements"
                  v-bind:taskType="'hourlyElements'"
                  v-bind:key="key"
                  v-bind:taskIndex="key"
                  />
    <ProjectTask  v-for="(item, key) in $store.getters.currentProjectModuleColumns.percentTasks"
                  v-bind:taskType="'percentTasks'"
                  v-bind:key="key + 'b'"
                  v-bind:taskIndex="key"
                  />
  </div>
</template>

<script>
import ProjectTask from './ProjectTask'
export default {
  name: 'ProjectPageTasks',
  data () {
    return {
      // mode: 'login' // login/register
    }
  },
  props: [],
  components: {
    ProjectTask
  },
  methods: {

  },
  computed: {

  },
  created () {
    console.log('** Tasks Component Loaded')
  }
}
</script>

<style scoped lang="scss">
  //
  // h2
  //
  h2 {
    color: black;
    margin-bottom: 20px;
  }


  //
  // Wrapper
  //
  .wrapper {
    position: relative;
    top: 135px;
    padding: 40px 50px;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;

    // Responsive Style
    // @media max-width: 1024px
    @media(max-width: 1024px) {
      top: 200px;
    }

    // Responsive Style
    // @media max-width: 768px
    @media(max-width: 768px) {
      padding-left: 20px;
      padding-right: 20px;
    }

    // Responsive Style
    // @media max-width: 520px
    @media(max-width: 520px) {
      top: 245px;
    }
  }
</style>
